import { RatesOption } from '../types/contracts'

export const DUTY_RATES_OPTIONS = [
  RatesOption.ConstantValue,
  RatesOption.PercentFromAmount,
]

export const NIGHT_RATES_OPTIONS = [
  RatesOption.ConstantValue,
  RatesOption.PercentFromAmount,
  RatesOption.PercentFromMinimalRate,
]

export const BONUS_RATES_OPTIONS = [
  RatesOption.ConstantValue,
  RatesOption.PercentFromAmount,
  RatesOption.PercentFromAmountAndLumpSum,
]

export const REWARD_RATES_OPTIONS = [RatesOption.ConstantValue]
